import Cognito from './cognito';
/* TODO: WARNING: A plugin must either be a function or an object with an "install" function.
       installメソッドを用意できる仕組みにしたい
*/
export default new Cognito();